var config = [
  {
    id: "algebra-tiles",
    displayName: "Algebra Tiles",
    iconFileName: "algebra-tiles_icon.png",
    videoId: "298413542"
  },
  {
    id: "base-ten-blocks",
    displayName: "Base Ten Blocks",
    iconFileName: "base-ten-blocks_icon.png",
    videoId: "298469049"
  },
  {
    id: "clock",
    displayName: "Clock",
    iconFileName: "clock_icon.png",
    videoId: "374242841"
  },
  {
    id: "color-tiles",
    displayName: "Color Tiles",
    iconFileName: "color-tiles_icon.png",
    videoId: "298469811"
  },
  {
    id: "cuisenaire-rods",
    displayName: "Cuisenaire® Rods",
    iconFileName: "cuisenaire-rods_icon.png",
    videoId: "298473845"
  },
  {
    id: "fraction-circles",
    displayName: "Fraction Circles",
    iconFileName: "fraction-circles_icon.png",
    videoId: "300142326"
  },
  {
    id: "fraction-tiles",
    displayName: "Fraction Tiles",
    iconFileName: "fraction-tiles_icon.png",
    videoId: "298503856"
  },
  {
    id: "geoboard",
    displayName: "Geoboard",
    iconFileName: "geoboard_icon.png",
    videoId: "298505963"
  },
  {
    id: "hundred-board",
    displayName: "Hundred Board",
    iconFileName: "hundred-board_icon.png",
    videoId: "298509567"
  },
  {
    id: "linking-cubes",
    displayName: "Linking Cubes",
    iconFileName: "linking-cubes_icon.png",
    videoId: "298510288"
  },
  {
    id: "money",
    displayName: "Money",
    iconFileName: "money_icon.png",
    videoId: null
  },
  {
    id: "number-lines",
    displayName: "Number Lines",
    iconFileName: "number-lines_icon.png",
    videoId: "298510733"
  },
  {
    id: "pattern-blocks",
    displayName: "Pattern Blocks",
    iconFileName: "pattern-blocks_icon.png",
    videoId: "298511386"
  },
  {
    id: "place-value-disks",
    displayName: "Place Value Disks",
    iconFileName: "place-value-disks_icon.png",
    videoId: "298561037"
  },
  {
    id: "rekenreks",
    displayName: "Rekenreks",
    iconFileName: "rekenreks_icon.png",
    videoId: "298563926"
  },
  {
    id: "two-color-counters",
    displayName: "Two-Color Counters",
    iconFileName: "two-color-counters_icon.png",
    videoId: "298210980"
  },
  {
    id: "xy-pegboard",
    displayName: "XY Coordinate Board",
    iconFileName: "xy-pegboard_icon.png",
    videoId: "298567208"
  }
]

export default config;
